import urlTool from '@/utils/urlTool';
import Gateway from '@/utils/Gateway';
import getAppsByBusiness from '@/pages/mng/workWeixin/api/getAppsByBusiness';
import { getInstallCallBackByUrlParams } from '@/components/app-install-panel/src/api';
// import { getWxkfVersion } from './getConfig';

export function hideCloseBtn(dialog) {
    const $close = dialog.$el && dialog.$el.querySelector && dialog.$el.querySelector('.v-dialog__close');

    if ($close) {
        $close.style.display = 'none';
    }
}

export function showErrorDialog(opts) {
    const { stausComment, title, confirmText, cancelText, descText, confirm, corpName } = opts || {};
    const statusObject = (stausComment && JSON.parse(stausComment)) || {};
    const { status, corp_name: statusCorpName } = statusObject;

    let render;
    const showCorpName = corpName || statusCorpName;

    if (status === 2) {
        render = createElement => {
            return createElement('div', {
                style: {
                    textAlign: 'center'
                },

                domProps: {
                    innerHTML: `请使用${descText}的企业微信<span style="color:#ff8345">${showCorpName}</span><br /> 来授权企业微信`
                }
            });
        };
    }

    const dialog = Vue.prototype.$confirm({
        title,
        confirmText,
        cancelText,
        render,
        confirm
    });

    hideCloseBtn(dialog);
}

function showInstallError(stausComment, installUrl) {
    showErrorDialog({
        title: '应用安装失败',
        confirmText: '重试安装应用',
        cancelText: '稍后重试',
        stausComment,
        descText: '授权',
        confirm: () => {
            window.location.href = installUrl;
        }
    });
}

function handleInstallError(opts) {
    const { isInstallCallBack } = getInstallCallBackByUrlParams() || {};
    const { app, installUrl } = opts || {};
    const { status_comment: statusComment } = app || {};

    if (isInstallCallBack) {
        showInstallError(statusComment, installUrl);
    }
}

function getWxkfAppBusiness(opts) {
    const { business } = opts || {};

    if (business) {
        return Promise.resolve(business);
    }

    return Promise.resolve('wxkf');

    // return getWxkfVersion()
    //     .then(version => {
    //         if (version === 'web') {
    //             return 'wxkf_3rdapp_web';
    //         }
    //         return 'wxkf';
    //     })
    //     .catch(() => {
    //         return 'wxkf';
    //     });
}

export function getAppInstallUrl(suiteId) {
    let jumpUrl = urlTool.removeURLParameter(window.location.href, 'suite_id');
    jumpUrl = urlTool.removeURLParameter(jumpUrl, 'wwappinstall');

    return Gateway.get('/v1/corp/wework/AppInstallUrl', {
        suite_id: suiteId,
        jump: jumpUrl
    });
}

export default function getWxkfInstallInfo(opts) {
    const { needGetInstallUrl, hideError } = opts || {};

    return new Promise(resolve => {
        let isInstall = false;

        getWxkfAppBusiness(opts).then(business => {
            getAppsByBusiness(business).then(data => {
                const { apps } = data || {};
                const app = (apps && apps[0]) || {};
                const { status, name, suite_id: suiteId } = app;

                if (status === 1 && !needGetInstallUrl) {
                    isInstall = true;
                    resolve({
                        app,
                        name,
                        isInstall
                    });
                } else if (suiteId) {
                    Gateway.get('/v1/basic/corp/wework/WxkfAuthURL', { suite_id: suiteId }).then(appInfo => {
                        const { url } = appInfo || {};
                        resolve({
                            app,
                            name,
                            isInstall,
                            installUrl: url
                        });

                        if (status === 2 && !hideError) {
                            handleInstallError({
                                app,
                                installUrl: url
                            });
                        }
                    });

                    // getAppInstallUrl(suiteId).then(appInfo => {
                    //     const { url } = appInfo || {};
                    //     resolve({
                    //         app,
                    //         name,
                    //         isInstall,
                    //         installUrl: url
                    //     });

                    //     if (status === 2 && !hideError) {
                    //         handleInstallError({
                    //             app,
                    //             installUrl: url
                    //         });
                    //     }
                    // });
                }
            });
        });
    });
}
